package com.exura.features.publicplans.domain.usecase

import com.exura.features.publicplans.domain.PublicPlansConstants
import com.exura.features.publicplans.domain.api.RefreshPlanStatisticsRequest
import com.exura.features.publicplans.domain.api.RefreshPlanStatisticsResponse
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import dev.gitlive.firebase.functions.FirebaseFunctions

class RefreshPlanStatisticsUseCase(
    private val functions: FirebaseFunctions,
) {
    suspend operator fun invoke(publicPlanId: String): Result<Boolean> = runCatching {
        val callable = functions.httpsCallable(PublicPlansConstants.Functions.GLOBAL_REFRESH_PLAN_STATISTICS)

        val response = callable.invoke(
            RefreshPlanStatisticsRequest(publicPlanId = publicPlanId)
        )
        val result = response.data<RefreshPlanStatisticsResponse>()

        if (result.success) {
            true
        } else {
            throw Exception(result.message ?: "Failed to refresh plan statistics")
        }
    }
}